import { render } from "./SingleCheckBox.vue?vue&type=template&id=4725cec7&scoped=true"
import script from "./SingleCheckBox.vue?vue&type=script&lang=js"
export * from "./SingleCheckBox.vue?vue&type=script&lang=js"

import "./SingleCheckBox.vue?vue&type=style&index=0&id=4725cec7&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4725cec7"]])

export default __exports__